module.exports = __webpack_public_path__ + "distribution-of-total-plaque-by-age-male.b075b15fa74f3c027e0701d297763b3b.png";